module.exports = new __parcel__URL__("firebase.47565468.svg").toString();